<template>
    <div>
        <BookingBack title='Order Booking' :textColor="'#333333'" :isCenter="true"/>
        <div class="serviceList">
            <div class="serviceRow" v-for="(item,index) in serviceData" :key="index" >
                <div class="serviceItem">
                    <div class="serviceTop">
                        <div class="serviceName">{{ item.name }}</div>
                        <div class="serviceRight">
                            <img class="close" src="@/assets/booking/close.png" alt="" @click="handleRemove(index)">
                            <div class="price">${{ item.price }}</div>
                        </div>
                    </div>
                    <!-- <div class="serviceTimeBox">
                        <van-cell title="Select Booking Date" :value="item.date" @click="show = true"  is-link/>
                        <van-calendar v-model="show" @confirm="onConfirm($event,item)" :show-confirm="false" color="#1E3C3E"/>
                        <van-cell title="Select Booking Time" :value="item.currentTime" @click="showTime = true"  is-link/>
                        <van-popup v-model="showTime" position="bottom">
                            <van-datetime-picker :min-hour="minHour" :min-minute="minMinute" :formatter="formatter" @cancel="showTime = false" @confirm="showTime = false" v-model="item.currentTime" type="time" title="Select Time" />
                        </van-popup>
                    </div> -->
                   <div class="serviceTimeGroup">
                        <van-cell
                            title="Select Booking Date"
                            :value="getServiceTimeLabel(item, index)"
                            @click="handleOpenTime(index)"
                            :is-link="index === 0"
                        />
                   </div>
                </div>
                <div class="line"></div>
                <div class="serviceBottom">
                   <div class="serviceInfo">
                        <div class="staff">Staff:</div>
                        <img class="avatar" :src="item.technician && getUrl(item.technician.image.file_path)" alt="">
                        <div class="name">{{ item.technician && item.technician.name || '--'}}</div>
                   </div>
                   <div class="chooseServiceBtn" @click="handleChoosePeople(index,item)">Select Staff</div>
                </div>
            </div>
        </div>
        <div style="width:100%;padding:0 1rem;box-sizing: border-box;">
            <div class="addBtn" @click="handleOpenShop">+ Add another service</div>
        </div>
        <div class="bookingBox">
            <div class="bookingItem">
                <div>$ {{totalPrice}}</div>
                <div class="bookingBtn" @click="handleGoPay">Book</div>
            </div>
        </div>
        <!-- 选择日期 -->
        <van-popup v-model="show" round position="bottom" :style="{ height: 'auto' }" closeable>
            <ChooseTime :business-hours="shopBusinessHours" @updateTime="updateTime" />
        </van-popup>
        <!-- Select Staff -->
        <van-popup
            v-model="showPeople"
            closeable
            round
            close-icon-position="top-right"
            position="bottom"
            :style="{ height: '50%',padding:'1rem',boxSizing: 'border-box' }"
        >
        <div>Select Staff</div>
        <div class="peopleList">
            <div  v-for="item in peopleList">
                <div class="peopleItem" @click="handlePeople(item)">
                    <van-image
                        class="avtar"
                        :src="getUrl(item.image.file_path)"
                    />
                    <div class="">
                        <div class="name">{{ item.name }}</div>
                        <div class="status">{{ item.remark }}</div>
                    </div>
                </div>
                <van-divider />
            </div>
             <van-empty v-if="peopleList.length == 0" description="No staff available for this time slot" />
        </div>
        </van-popup>
        <!-- 选择店铺 -->
        <van-popup
            v-model="showShop"
            closeable
            round
            close-icon-position="top-right"
            position="bottom"
            :style="{ height: '90%',padding:'1rem',boxSizing: 'border-box' }"
        >
            <div>Add Service</div>
            <div class="searchData" v-if="shopDetail != null">
                <div class="shopInfo">
                    <div>{{ shopDetail.name }}</div>
                    <div class="address">{{ shopDetail.address }}</div>
                </div>
                <div class="scoreInfo">
                    <div class="scoreInfo">{{ shopDetail.score }}</div>
                    <div style="margin-top:0.25rem">
                        <ShopStar :num="Number(shopDetail.score)"/>
                    </div>
                </div>
            </div>
            <ShopService v-if="shopDetail != null" :data="shopDetail.service || {}" :isPopup="true"/>
        </van-popup>
    </div>
</template>
<script>
import myMixin from '@/utils/myMixin';
import { Notify } from 'vant'
import { Dialog,Toast  } from 'vant';
import BookingBack from '@/components/Booking/back.vue'
import ShopService from '@/views/shop/service.vue'
import ShopStar from '@/components/Shop/ShopStar.vue'
import ChooseTime from '@/components/ChooseTime/index.vue'
export default {
    name:'Booking',
    mixins: [myMixin],
    data(){
        return {
            totalPrice:0,
            showTime:false,
            show: false,
            showPeople:false,
            showShop:false,
            activeIndex:0,
            timeIndex:0,
            chooseIndex:null,
            minHour:null,
            minMinute:null,
            activeDayIndex:0,
            serviceData:[
            ],
            peopleList:[
            ],
            shopDetail:null,
            shopSupplierId:null,
            appId:10001,
            activeRowIndex:0,
        }
    },
    components:{
        BookingBack,
        ShopService,
        ShopStar,
        ChooseTime
    },
    created(){
        // this.getSupplierDetail()
    },
    computed:{
        shopBusinessHours(){
            return this.shopDetail || {}
        },
        merchantTimezone(){
            return (this.shopDetail && this.shopDetail.timezone) || null
        }
    },
    watch:{
        serviceData: {
            handler(newVal, oldVal) {
                this.totalPrice = 0
                for(let i in newVal ){
                    this.totalPrice += Number(newVal[i].price)
                }
            },
            deep: true, // 深度监听
            // immediate: true // 初始化时立即执行一次
        },
    },
    mounted(){
        // 进入预约页立即校验 token 有效性，失效时拦截器自动清除 token 并弹登录提示
        this.$api.getUserDetail().catch(() => {})
        let data = JSON.parse(this.$route.query.data) || {}
        this.serviceData.push(data)
        this.shopSupplierId = data.shop_supplier_id || this.$route.query.shop_supplier_id || null
        this.appId = data.app_id || this.$route.query.app_id || 10001
        this.getSupplierDetail()
        this.$bus.$on('closePopup', (data) => {
            let newData = {...data}
            newData.date = this.getCurrentDate()
            newData.currentTime = this.getCurrentTime()
            this.showShop = false
            this.serviceData.push(newData)
            // 添加新Services后：若已选择第一条时间，则自动给后续Services顺延时间
            this.recalculateChainedTimesFrom(0)
        })
    },
    getNowYearData(index = 0){
    },
    beforeDestroy() {
        this.$bus.$off('closePopup')
    },
    methods: {
        async handleOpenTime(index){
            // 第二个及之后的Services：时间Auto-arranged，不允许手动选择
            if (index > 0) {
                Toast('From the second service onward, time is auto-arranged. No manual selection needed.')
                return
            }
            this.activeRowIndex = index
            if(!this.shopDetail){
                await this.getSupplierDetail()
            }
            this.show = true
        },
        updateTime(val){
            this.show = false
            this.serviceData[this.activeRowIndex].start_time = val
            // 重新计算当前及后续Services的时间（Auto-arranged）
            this.recalculateChainedTimesFrom(this.activeRowIndex)
        },
        getServiceTimeLabel(item, index) {
            if (item && item.start_time && item.end_time) {
                return `${String(item.start_time).slice(0, -3)} - ${String(item.end_time).slice(0, -3)}`
            }
            if (index === 0) return 'Booking Date'
            return 'Auto-arranged'
        },
        calcEndTime(startTime, service) {
            if (!startTime) return null
            // minute/hour 可能来自接口字段：minute 表示分钟数；hour 可选
            const hour = Number((service && service.hour) || 0)
            const minute = Number((service && service.minute) || 0)
            const timeobj = this.dateToTimestamp(startTime)
            const endStamp = timeobj.s + this.getMinuteS(minute, hour)
            return this.timestampToDate(endStamp)
        },
        // 从指定下标开始，按“前一个结束=下一个开始”规则Auto-arranged
        recalculateChainedTimesFrom(startIndex = 0) {
            const list = this.serviceData || []
            for (let i = startIndex; i < list.length; i++) {
                const cur = list[i]
                const oldStart = cur && cur.start_time
                const oldEnd = cur && cur.end_time
                if (i === 0) {
                    cur.end_time = this.calcEndTime(cur.start_time, cur)
                } else {
                    const prev = list[i - 1]
                    if (prev && prev.end_time) {
                        cur.start_time = prev.end_time
                        cur.end_time = this.calcEndTime(cur.start_time, cur)
                    } else {
                        cur.start_time = null
                        cur.end_time = null
                    }
                }
                // 时间发生变化：清空技师（避免旧技师在新时间段不可用）
                if (cur && (cur.start_time !== oldStart || cur.end_time !== oldEnd)) {
                    cur.technician = null
                }
            }
        },
        formatter(type, val) {
            if (type === 'hour') {
                if( Number(val) <= 12 ){
                   return val + 'AM'
                }else{
                   return val + 'PM'
                }
            }
            if (type === 'minute') {
                return val + 'minute'
            }
        },
        getCurrentTime(isSeconds=false){
            const date = new Date()
            // 获取时、分、秒
            const hours = this.padZero(date.getHours())
            const minutes = this.padZero(date.getMinutes())
            const seconds = this.padZero(date.getSeconds())
            // 格式化时间（可自定义格式）
            if( isSeconds ){
                return `:${seconds}`
            }else{
                return `${hours}:${minutes}`
            }
        },
        // 补零函数：确保数字为两位数
        padZero(num) {
            return num < 10 ? `0${num}` : num
        },
        getCurrentDate() {
            const date = new Date()
            // 格式化日期：年-月-日
            const year = date.getFullYear()
            const month = this.formatNumber(date.getMonth() + 1) // 月份从0开始，需+1
            const day = this.formatNumber(date.getDate())
            return `${year}-${month}-${day}`
        },
        // 辅助方法：补全两位数（如 3 → '03'）
        formatNumber(n) {
            return n < 10 ? `0${n}` : n
        },
        async getSupplierDetail(){
            if(!this.shopSupplierId){
                Notify({ type: 'danger', message: 'No store info available. Cannot add services.' })
                return
            }
            try{
                const params = {
                    app_id: this.appId,
                    shop_supplier_id: this.shopSupplierId
                }
                const res = await this.$api.getSupplierDetail(params)
                if(res.code == 1){
                    this.shopDetail = res.data && res.data.detail || {}
                }else{
                    Notify({ type: 'danger', message: res.msg || 'Failed to load service list' })
                }
            }catch(error){
                console.error(error)
                Notify({ type: 'danger', message: 'Failed to load service list' })
            }
        },
        formatDate(date) {
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },
        onConfirm(date,item) {
            this.show = false;
            item.date = this.formatDate(date)
        },
        handleRemove(index){
            Dialog.confirm({
                title: 'Delete',
                message: 'Are you sure you want to delete this booked service?',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
            })
            .then(() => {
               this.serviceData.splice(index,1)
               // Delete后重新顺延时间
               this.recalculateChainedTimesFrom(0)
            })
            .catch(() => {
            });
        },
        // 选择技师
        handleChoosePeople(index,item){
            this.activeRowIndex = index
            if( item.start_time ){
                this.showPeople = true
                let data = {
                    app_id:10001,
                    service_id:item.id,
                    start_time:this.toApiTimestamp(item.start_time),
                    end_time:this.toApiTimestamp(item.end_time)
                }
                this.$api.getAvailableTechnicians(data).then(res=>{
                    if(res.code == 1){
                        this.peopleList = res.data || []
                    }else{
                    }
                })
            }else{
                Notify({ type: 'danger', message: 'Please select a booking date first' })
            }
        },
        handlePeople(item){
            this.serviceData[this.activeRowIndex].technician = item
            this.showPeople = false
        },
        handleOpenShop(){
            this.showShop = true
            // 调用接口获取Services列表
            this.getSupplierDetail()
        },
        handleGoPay(){
            const data  = this.serviceData
            let arr = []
            let isError = false
            for( let i in data ){
                if( data[i].technician && data[i].technician.id ){
                    arr.push({
                        service_id:data[i].id,
                        technician_id:data[i].technician.id,
                        start_time:this.toApiTimestamp(data[i].start_time),
                        end_time:this.toApiTimestamp(data[i].end_time)
                    })
                }else{
                    isError = true
                    Notify({ type: 'danger', message: 'Please select a staff member first' })
                    break
                }
            }
            if( !isError ){
                if( arr.length > 0 ){
                    const orderData = {
                        service:JSON.stringify(arr)
                    }
                    this.$api.getOderConfirm(orderData).then(res=>{
                        if(res.code == 1){
                            Toast.success('Booking successful')
                            // Booking successful后刷新一次当前用户信息（用于支付页权限判断等）
                            // 接口返回：{ coupon, userInfo{is_replace...}, ... }
                            this.$api.getUserDetail().then(userRes => {
                                if (userRes && userRes.code === 1 && userRes.data) {
                                    try {
                                        localStorage.setItem('userInfo', JSON.stringify(userRes.data.userInfo || {}))
                                        localStorage.setItem('userDetail', JSON.stringify(userRes.data || {}))
                                    } catch (e) {
                                        // ignore storage errors
                                    }
                                }
                            }).catch(() => {})
                            setTimeout(()=>{
                                this.$router.push({path:'/payOrder',query:{orderData:JSON.stringify(data)}})
                            },1500)
                        }else{
                            Toast.fail(res.msg)
                        }
                    })
                }else{
                    Notify({ type: 'danger', message: 'Please add service items first' })
                }
            }
            // this.$router.push('payOrder')
        },
        getMinuteS(minute,hour){
            let s = 0
            let min = minute
            if( hour > 0 ){
                min += hour * 60
            }
            return Number(min) * 60
        },
        dateToTimestamp(dateStr) {
            // 处理 "-" 分隔符的兼容性问题（部分浏览器对 "-" 支持不佳）
            const normalizedStr = dateStr.replace(/-/g, '/');
            const date = new Date(normalizedStr);
            // 验证日期有效性
            if (isNaN(date.getTime())) {
                throw new Error('Invalid date format');
            }
            return {
                ms: date.getTime(),      // 毫秒级时间戳（13位）
                s: Math.floor(date.getTime() / 1000)  // 秒级时间戳（10位）
            };
        },
        toApiTimestamp(time) {
            if (!time) return ''
            if (typeof time === 'number') {
                return time.toString().length === 13 ? Math.floor(time / 1000) : time
            }
            if (/^\d+$/.test(String(time))) {
                const timestamp = Number(time)
                return String(time).length === 13 ? Math.floor(timestamp / 1000) : timestamp
            }
            const tz = this.merchantTimezone
            if (tz) {
                const ts = this.localTimeToTimestamp(String(time), tz)
                if (ts !== null) return ts
            }
            return this.dateToTimestamp(String(time)).s
        },
        timestampToDate(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
            // 处理秒级时间戳（如果小于13位，默认是秒级）
            if (timestamp.toString().length === 10) {
                timestamp *= 1000;
            }
            const date = new Date(timestamp);
            if (isNaN(date.getTime())) {
                throw new Error('Invalid timestamp');
            }
            // 获取日期各部分
            const year = date.getFullYear();
            const month = this.padZero(date.getMonth() + 1); // 月份0-11，需+1
            const day = this.padZero(date.getDate());
            const hours = this.padZero(date.getHours());
            const minutes = this.padZero(date.getMinutes());
            const seconds = this.padZero(date.getSeconds());
            // 根据格式替换
            return format
                .replace('YYYY', year)
                .replace('MM', month)
                .replace('DD', day)
                .replace('HH', hours)
                .replace('mm', minutes)
                .replace('ss', seconds);
        }
    },
}
</script>
<style lang="scss" scoped>
    .serviceTimeGroup{
        width: 100%;
    }
    .searchData{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #F4F4F4;
        border-radius: .25rem;
        padding: 0.5rem;
        box-sizing: border-box;
        margin-top: 1rem;
        font-size: .875rem;
        .shopInfo{
             .address{
                font-size: .75rem;
                color: #666666;
                margin-top: 0.25rem;
            }
        }
        .scoreInfo{
            text-align: right;
        }
    }
    .peopleList{
        margin: 1rem 0;
        .peopleItem{
            display: flex;
            align-items: center;
            font-size: .875rem;
            margin-bottom: 1rem;
            .avtar{
                width: 3rem;
                height: 3rem;
                border-radius: 100%;
                overflow: hidden;
                margin-right: 0.5rem;
            }
            .status{
                color: #00C341;
            }
        }
    }
    .bookingBox{
        width: 100%;
        height: 6.5rem;
        margin-top: 1rem;
        .bookingItem{
        width: 100%;
        position: fixed;
        bottom: 0;
        height:6.5rem;
        background: #fff;
        border-top: 1px solid #EEEEEE;
        padding: 0.5rem 1rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        .bookingBtn{
            width: 100%;
            height: 2.75rem;
            border-radius: .25rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #1E3C3E;
            color: #fff;
            font-size: .875rem;
        }
    }
    }
    .addBtn{
        width: 100%;
        height: 2rem;
        border-radius: 2.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        background: #1E3C3E;
    }
    .serviceList{
        width: 100%;
        // 让第一条Services卡片与顶部栏之间留一点呼吸空间
        padding: .5rem 1rem 0;
        box-sizing: border-box;
        font-size: .875rem;
        .line{
            width: 100%;
            height: 1px;
            background: #CCCCCC;
            margin: 1rem 0;
        }
        .serviceRow{
            width: 100%;
            background: #F4F4F4;
            border-radius: .5rem;
            padding: 1rem;
            box-sizing: border-box;
            margin-bottom: 1rem;
            .serviceBottom{
                display: flex;
                align-items: center;
                justify-content: space-between;
                .chooseServiceBtn{
                    width: auto;
                    height: 2rem;
                    background: #fff;
                    font-size: .75rem;
                    color: #1A3232;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 0.5rem;
                    box-sizing: border-box;
                    border-radius: .25rem;
                }
                .serviceInfo{
                    display: flex;
                    align-items: center;
                    .avatar{
                        width: 2rem;
                        height: 2rem;
                        border-radius: 100%;
                        display: block;
                        margin: 0 0.5rem;
                    }
                }
            }
            .serviceItem{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-direction: column;
                .serviceTop{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
                .serviceTimeBox{
                    width: 100%;
                    margin: 0.5rem 0;
                }
                .serviceRight{
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    .price{
                        margin: 0.5rem 0;
                    }
                    .time{
                        color: #666666;
                    }
                    .close{
                        width: 1.125rem;
                        height: 1.125rem;
                        display: block;
                        cursor: pointer;
                        position: relative;
                        // 关闭按钮向右上微调一点（不影响布局流）
                        top: -1rem;
                        right: -1rem;
                    }
                }
            }
        }
    }
</style>
